module.exports = __webpack_public_path__ + "static/media/convites@2x.09e4c7b3.jpg";